

export const  IS_LOADING_TRUE = "IS_LOADING_TRUE";
export const  IS_LOADING_FALSE = "IS_LOADING_FALSE";

export const WHISLIST="WHISLIST";

export const WHISLIST_DATA = "WHISLIST_DATA";




